import React, { useState } from 'react';
import { ShieldCheck, CheckCircle, Download, MonitorSmartphone, Lock, ChevronDown, ChevronUp, Star, BookOpen, Code, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PurchaseSectionProps {
  id?: string;
  showFooter?: boolean;
}
export function PurchaseSection({
  id,
  showFooter = false
}: PurchaseSectionProps) {
  const [selectedOffer, setSelectedOffer] = useState<'upsell' | 'standard'>('upsell');
  const [showUpsellDetails, setShowUpsellDetails] = useState(false);
  const offers = {
    upsell: {
      title: 'Manual Académico + MEGAPACK JAVASCRIPT FÁCIL',
      price: '26.990',
      originalPrice: '99.990',
      checkoutUrl: 'https://checkout.ecompradigital.online/cart/46950105743548:1'
    },
    standard: {
      title: 'Solo Manual Académico de Programación',
      price: '19.990',
      originalPrice: '79.990',
      checkoutUrl: 'https://checkout.ecompradigital.online/cart/46902949970108:1'
    }
  };
  const currentOffer = offers[selectedOffer];
  return <section id={id} className="py-6 md:py-12 px-4 bg-dark-800" data-id="element-92">
      <div className="max-w-xl mx-auto bg-dark-900 rounded-2xl shadow-xl border border-dark-700 overflow-hidden" data-id="element-93">
        {/* Header badge */}
        <div className="bg-brand-500 py-2 text-center" data-id="element-94">
          <h3 className="text-sm md:text-base font-black uppercase tracking-wider text-white" data-id="element-95">
            🔥 OFERTA DE LANZAMIENTO
          </h3>
        </div>

        <div className="p-5 md:p-6" data-id="element-96">
          <p className="text-sm md:text-base text-brand-300 font-medium mb-6 text-center px-2" data-id="element-97">
            <span className="font-bold text-white" data-id="element-98">
              TODO el material de Programación I a IV
            </span>{' '}
            listo para usar: clases, diapositivas, material teorico resumido,
            actividades y juegos didácticos, trabajos practicos y evaluaciones.
          </p>

          {/* Offer Selection */}
          <div className="space-y-4 mb-6" data-id="element-99">
            {/* Upsell Option */}
            <div onClick={() => setSelectedOffer('upsell')} className={`relative cursor-pointer rounded-xl border-2 p-4 transition-all duration-200 ${selectedOffer === 'upsell' ? 'border-brand-400 bg-brand-500/10' : 'border-dark-700 bg-dark-800 hover:border-dark-600'}`} data-id="element-100">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-dark-900 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-101">
                <Star size={12} fill="currentColor" data-id="element-102" /> MÁS ELEGIDA
              </div>
              <div className="flex items-center gap-3 mt-2" data-id="element-103">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'upsell' ? 'border-brand-400' : 'border-gray-500'}`} data-id="element-104">
                  {selectedOffer === 'upsell' && <div className="w-2.5 h-2.5 bg-brand-400 rounded-full" data-id="element-105"></div>}
                </div>
                <div data-id="element-106">
                  <h4 className={`font-bold text-sm md:text-base leading-tight ${selectedOffer === 'upsell' ? 'text-white' : 'text-gray-300'}`} data-id="element-107">
                    Manual Académico +{' '}
                    <span className="text-brand-400" data-id="element-108">
                      MEGAPACK JAVASCRIPT FÁCIL
                    </span>
                  </h4>
                  <p className="text-xs text-gray-400 mt-1" data-id="element-109">
                    La experiencia completa para enseñar programación moderna.
                  </p>
                </div>
              </div>

              {/* Upsell Details Toggle */}
              <div className="mt-4 pl-8" data-id="element-110">
                <button onClick={e => {
                e.stopPropagation();
                setShowUpsellDetails(!showUpsellDetails);
              }} className="text-xs font-bold text-brand-400 flex items-center gap-1 hover:text-brand-300 transition-colors bg-dark-900/50 px-3 py-1.5 rounded-lg border border-dark-700" data-id="element-111">
                  ¿Qué incluye el Megapack JavaScript Fácil?
                  {showUpsellDetails ? <ChevronUp size={14} data-id="element-112" /> : <ChevronDown size={14} data-id="element-113" />}
                </button>

                {showUpsellDetails && <div className="mt-3 bg-dark-900 rounded-xl p-4 border border-brand-500/30 shadow-inner text-sm animate-popup" data-id="element-114">
                    <div className="flex items-center gap-2 mb-3" data-id="element-115">
                      <div className="bg-yellow-500/20 p-1.5 rounded-md" data-id="element-116">
                        <Zap size={18} className="text-yellow-500" data-id="element-117" />
                      </div>
                      <h5 className="font-black text-white text-base" data-id="element-118">
                        MEGA PACK JAVASCRIPT FÁCIL
                      </h5>
                    </div>

                    <p className="text-gray-300 font-medium mb-4 leading-relaxed" data-id="element-119">
                      La forma más simple de aprender y enseñar JavaScript.
                      Transformamos conceptos complejos en explicaciones claras,
                      visuales y fáciles de comprender.
                    </p>

                    <p className="text-brand-300 text-xs font-bold mb-3 uppercase tracking-wider" data-id="element-120">
                      Ideal para estudiantes y docentes
                    </p>

                    <ul className="space-y-2 mb-5" data-id="element-121">
                      {['Explicaciones simples y directas', 'Ejemplos cotidianos fáciles de entender', 'Progresión pedagógica paso a paso', '6 tomos completos de formación', 'JavaScript moderno aplicado al mundo real', 'Funciones, Arrays, Objetos, APIs y más', 'Buenas prácticas de profesionales'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-122">
                          <CheckCircle size={16} className="text-brand-400 shrink-0 mt-0.5" data-id="element-123" />
                          <span data-id="element-124">{item}</span>
                        </li>)}
                    </ul>

                    <div className="bg-dark-800 p-3 rounded-lg border border-dark-700 mb-4" data-id="element-125">
                      <div className="flex items-start gap-2" data-id="element-126">
                        <BookOpen size={18} className="text-brand-400 shrink-0 mt-0.5" data-id="element-127" />
                        <p className="text-gray-300 text-sm font-medium" data-id="element-128">
                          <span className="text-white font-bold" data-id="element-129">
                            Más de 360 páginas
                          </span>{' '}
                          de contenido organizado para que aprender JavaScript
                          sea mucho más fácil, rápido y comprensible.
                        </p>
                      </div>
                    </div>

                    <div className="space-y-1 text-center font-bold text-gray-200" data-id="element-130">
                      <p className="text-red-400" data-id="element-131">
                        Menos confusión.{' '}
                        <span className="text-brand-400" data-id="element-132">Más comprensión.</span>
                      </p>
                      <p className="text-red-400" data-id="element-133">
                        Menos teoría complicada.{' '}
                        <span className="text-brand-400" data-id="element-134">
                          Más aprendizaje real.
                        </span>
                      </p>
                    </div>

                    <p className="text-center text-gray-400 text-xs mt-4 italic" data-id="element-135">
                      Una ruta diseñada para que cualquier persona pueda
                      entender JavaScript de forma clara desde el primer
                      capítulo.
                    </p>
                  </div>}
              </div>
            </div>

            {/* Standard Option */}
            <div onClick={() => setSelectedOffer('standard')} className={`cursor-pointer rounded-xl border-2 p-4 transition-all duration-200 ${selectedOffer === 'standard' ? 'border-brand-400 bg-brand-500/10' : 'border-dark-700 bg-dark-800 hover:border-dark-600'}`} data-id="element-136">
              <div className="flex items-center gap-3" data-id="element-137">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOffer === 'standard' ? 'border-brand-400' : 'border-gray-500'}`} data-id="element-138">
                  {selectedOffer === 'standard' && <div className="w-2.5 h-2.5 bg-brand-400 rounded-full" data-id="element-139"></div>}
                </div>
                <div data-id="element-140">
                  <h4 className={`font-bold text-sm md:text-base ${selectedOffer === 'standard' ? 'text-white' : 'text-gray-300'}`} data-id="element-141">
                    Solo Manual Académico de Programación
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Price Display */}
          <div className="text-center mb-6 bg-dark-800 py-4 rounded-xl border border-dark-700" data-id="element-142">
            <p className="text-gray-500 font-bold line-through text-sm mb-1" data-id="element-143">
              ${currentOffer.originalPrice} ARS
            </p>
            <p className="text-4xl md:text-5xl font-black text-brand-400 leading-none mb-2" data-id="element-144">
              ${currentOffer.price}
              <span className="text-xl" data-id="element-145"> ARS</span>
            </p>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-146">
              Pago único • Acceso inmediato
            </p>
          </div>

          {/* Benefits row */}
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 mb-6 text-xs font-semibold text-gray-300" data-id="element-147">
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-148">
              <Download className="text-brand-400" size={14} data-id="element-149" />
              Descarga inmediata
            </span>
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-150">
              <CheckCircle className="text-brand-400" size={14} data-id="element-151" />
              Acceso de por vida
            </span>
            <span className="flex items-center gap-1 bg-dark-800 px-2 py-1 rounded-md border border-dark-700" data-id="element-152">
              <MonitorSmartphone className="text-brand-400" size={14} data-id="element-153" />
              Celular y PC
            </span>
          </div>

          <CTAButton checkoutUrl={currentOffer.checkoutUrl} className="w-full text-base md:text-lg py-4 shadow-lg shadow-brand-500/20" data-id="element-154" />

          <div className="flex items-center justify-center gap-2 mt-4 text-xs font-medium text-[#93959C]" data-id="element-155">
            <Lock size={12} data-id="element-156" /> Pago 100% seguro
            <span className="mx-1" data-id="element-157">•</span>
            <ShieldCheck size={12} className="text-brand-400" data-id="element-158" /> Garantía 7 días
          </div>
        </div>
      </div>

      {showFooter && <div className="text-center mt-8 max-w-2xl mx-auto space-y-3 text-gray-400 font-medium text-base px-2" data-id="element-159">
          <p data-id="element-160">
            <span className="text-red-400 font-bold" data-id="element-161">
              El precio actual es únicamente por lanzamiento.
            </span>{' '}
            Este sistema continuará creciendo con nuevos contenidos, nuevas
            clases, nuevas diapositivas y nuevos recursos para docentes de
            Programación.
          </p>
          <p data-id="element-162">Y cuando eso ocurra, el valor del acceso aumentará.</p>
          <p className="text-gray-200 font-bold mt-4" data-id="element-163">
            Los docentes que ingresen hoy conservan el precio actual y obtienen
            acceso completo a todas las actualizaciones futuras.
          </p>
        </div>}
    </section>;
}